import { UpgradeAdapter } from '@angular/upgrade';
export const upgradeAdapter = new UpgradeAdapter();


/** WEBPACK FOOTER **
 ** ./src/upgrade_adapter.ts
 **/